import { connect } from 'react-redux'
import ModalActions from '../../../../../Redux/ModalRedux'
import OfflineDevicesBySiteModal from './offline-devices-by-site-modal'
import OfflineDevicesBySiteModalSelector from './offline-devices-by-site-modal.selector'
import { pipe } from 'ramda'
import { translate } from 'react-translate'

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch(ModalActions.modalClose())
  }
}

export default pipe(
  translate('CardsModals'),
  connect(
    OfflineDevicesBySiteModalSelector,
    mapDispatchToProps
  )
)(OfflineDevicesBySiteModal)
